module.exports = __webpack_public_path__ + "img/Magnuss57.0c23b866.jpg";